// src/content/steps.js
// Who acts at each step, shown as a small marker next to the step. Uses the same markers as the
// selection status in step 6 (🤖 AI, 👤 human, 🤖 + 👤 both). Step names stay as in STEPS
// (config/t4rConfig.js); they are agreed with the partners and must not be renamed here.

export const ROLE = {
  you: { emoji: "👤", label: "You fill in this step" },
  ai: { emoji: "🤖", label: "The tool's AI suggests" },
  both: { emoji: "🤖 + 👤", label: "The AI suggests, you decide" },
};

// Index = step number (0 = onboarding has no marker).
export const STEP_ROLES = [null, "you", "you", "you", "you", "ai", "both", "both"];
